module.exports = __webpack_public_path__ + "fwm_h5/img/jszlogo.f95eab4b.png";